import { Component, EventEmitter, OnInit, Output } from '@angular/core';


@Component({
  selector: 'app-textblock',
  templateUrl: './textblock.component.html',
  styleUrls: ['./textblock.component.less']
})
export class TextblockComponent implements OnInit {
  @Output() playClicked = new EventEmitter();
  constructor() { }

  btnPlay() {
    this.playClicked.emit(null);
  }
  ngOnInit(): void {
  }

}
